import { render, staticRenderFns } from "./labelArchList.vue?vue&type=template&id=65b5087f&scoped=true&"
import script from "./labelArchList.vue?vue&type=script&lang=js&"
export * from "./labelArchList.vue?vue&type=script&lang=js&"
import style0 from "./labelArchList.vue?vue&type=style&index=0&id=65b5087f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5087f",
  null
  
)

component.options.__file = "labelArchList.vue"
export default component.exports